import React from 'react';
import { NormalPeoplePicker } from '@fluentui/react';
import { MessageConst, MessageConstEn } from '../../const/MessageConst';

const FieldEmployee = (props) => {

    const onFilterChagned = async (filterText, currentPersonas) => {
        let tData = [];
        if (filterText) {
            if (props.API) {
                await props.API.get(props.dataurl + "?search=" + filterText).then(response => {
                    if (response.status === 200 && response.data?.rettype === 0) {
                        if (response.data?.retdata?.length > 0) {
                            tData = response.data.retdata;
                        }
                    }
                });
            }
        }

        tData?.map(r => {
            r.secondaryText = r.secondarytext ? r.secondarytext : '--'
        });

        return tData;
    };


    const onEmptyInputFocus = async () => {

        let tData = [];

        if (props.API) {
            await props.API.get(props.dataurl + "?lfr=true").then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    if (response.data.retdata?.length > 0) {
                        tData = response.data.retdata;
                    }
                }
            });
        }

        tData?.map(r => {
            r.secondaryText = r.secondarytext ? r.secondarytext : '--'
        });

        return tData;
    }

    const onSelectEmp = (p_value) => {
        if (p_value?.length > 0) {
            props.onChanged(p_value[0].key, p_value[0].secondaryText, props.keyfield, p_value[0].email);
        }
    }

    return (
        <div>
            <div style={{ fontWeight: 600, fontSize: 14 }}>{props.title}</div>
            <div style={{ marginTop: 6 }}>
                <NormalPeoplePicker
                    onResolveSuggestions={onFilterChagned}
                    onEmptyInputFocus={onEmptyInputFocus}
                    resolveDelay={1000}
                    itemLimit={1}
                    onChange={onSelectEmp}
                    pickerSuggestionsProps={{
                        noResultsFoundText: 'Харуулах мэдээлэлгүй байна',
                    }}
                    inputProps={{
                        placeholder: props.title
                    }}
                />
                {(props.required && !props.defaultValue && props.checkreq) ? (
                    <div style={{ color: 'rgb(164, 38, 44)', fontSize: 12, fontWeight: 400, paddingTop: 5 }}>
                        {props.title + (props.lang == "en" ? MessageConstEn.fieldRequired : MessageConst.fieldRequired)}
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default FieldEmployee;